// extracted by mini-css-extract-plugin
module.exports = {"bulkActions":"bulkActions__-tPBV","text":"text__zMFzw","inputs":"inputs__jfISR","input":"input__lGRS-","buttons":"buttons__sPcpU"};